export const SET_SURVEY_DATA = 'SET_SURVEY_DATA'



// WEBPACK FOOTER //
// ./src/store/modules/clientsurvey/types.js